import { noop } from 'lodash'
import { BooleanFilterInputPropsType } from '../../../utils/types/tableFilterTypes'
import {
  BOOLEAN_FILTER_OPTIONS,
  DropdownType,
  filterOperatorValues,
} from '../../../utils'
import { SelectDropDown } from '../../select-dropdown/SearchDropDown'
import { useEffect, useState } from 'react'
import { SvgCross, SvgFunnel } from '../../../assets/images'

export const BooleanFilterInput = <T,>({
  columnData,
  handleFilterChange = noop,
  search_key,
  dataQaId,
  filterOperator,
  filterObject,
  tabIndex,
}: BooleanFilterInputPropsType<T>) => {
  const options =
    columnData.filterData?.booleanOptions ?? BOOLEAN_FILTER_OPTIONS
  const optionsWithoutAll = options.filter((option) => option.label !== 'All')
  const [value, setValue] = useState('')
  const [disabledInput, setDisabledInput] = useState(false)
  const [isFilterApplied, setIsFilterApplied] = useState(false)
  const onBooleanFilterSelect = (e: DropdownType<boolean>) => {
    setValue(e.value)
    handleFilterChange({
      search_key: search_key,
      operator: filterOperator?.value ?? '',
      search_value: e.search_value !== null ? [String(e.search_value)] : [],
    })
  }

  const isNullOrNotNull = () => {
    return (
      filterOperator?.value === filterOperatorValues.IS_NULL ||
      filterOperator?.value === filterOperatorValues.IS_NOT_NULL
    )
  }

  const handleClearFilterButtonClick = () => {
    setValue('')
    handleFilterChange({
      search_key: search_key,
      operator: filterOperator?.value ?? '',
      search_value: [],
    })
  }

  useEffect(() => {
    if (isNullOrNotNull()) {
      setValue('')
      handleFilterChange({
        search_key: search_key,
        operator: filterOperator?.value ?? '',
        search_value: [''],
      })
      setDisabledInput(true)
    } else {
      if (
        filterObject?.search_criteria?.[search_key]?.operator ===
          filterOperatorValues.IS_NULL ||
        filterObject?.search_criteria?.[search_key]?.operator ===
          filterOperatorValues.IS_NOT_NULL
      ) {
        setValue(optionsWithoutAll[0].value)
        handleFilterChange({
          search_key: search_key,
          operator: filterOperator?.value ?? '',
          search_value: [],
        })
      }
      setDisabledInput(false)
    }
  }, [filterOperator])

  useEffect(() => {
    if (
      filterObject &&
      search_key &&
      filterObject?.search_criteria?.[search_key]
    ) {
      //NOTE: Setting default value in case of initial render ot default filter
      const raw = filterObject?.search_criteria?.[search_key]?.search_value?.[0]
      setValue(raw ?? '')
      setIsFilterApplied(true)
    } else setIsFilterApplied(false)
  }, [filterObject])

  return (
    <div className="flex-1">
      <div className="relative flex items-center">
        <div className="absolute left-1 mt-[1px] px-1 z-10">
          <SvgFunnel
            width={'16'}
            height={'16'}
            className={`cursor-default ${
              isFilterApplied
                ? 'svg-path-fill-secondary'
                : 'svg-path-fill-accent-300'
            }
            `}
          />
        </div>
        <SelectDropDown
          className="bg-white min-w-[8rem]"
          name=""
          label=""
          onChange={(e) => {
            onBooleanFilterSelect(e)
          }}
          options={optionsWithoutAll}
          defaultValue={value}
          dataQaId={`${dataQaId}-boolean-dropdown`}
          disabled={disabledInput}
          placeholder=""
          isFilter={true}
          tabIndex={tabIndex}
          isCrossable={false}
        />
        {isNullOrNotNull() || value ? (
          <div className="absolute right-7 px-1 z-10">
            <SvgCross
              width={'10'}
              height={'10'}
              className={'svg-path-fill-secondary focus:outline-none'}
              onClick={() => {
                handleClearFilterButtonClick()
              }}
              tabIndex={-1}
            />
          </div>
        ) : null}
      </div>
    </div>
  )
}
